import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=8a4a276e&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=8a4a276e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4a276e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a4a276e')) {
      api.createRecord('8a4a276e', component.options)
    } else {
      api.reload('8a4a276e', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=8a4a276e&scoped=true&", function () {
      api.rerender('8a4a276e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/uform/Edit.vue"
export default component.exports